const LOGIN_SESSION_KEY = 'loginSessionId';
const PROFILE_WARNING_PREFIX = 'profileWarningShown:';

const createSessionId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const startLoginSession = () => {
  const sessionId = createSessionId();
  localStorage.setItem(LOGIN_SESSION_KEY, sessionId);
  return sessionId;
};

export const ensureLoginSession = () => {
  const current = localStorage.getItem(LOGIN_SESSION_KEY);
  return current || startLoginSession();
};

export const getProfileWarningKey = () => {
  const sessionId = ensureLoginSession();
  return `${PROFILE_WARNING_PREFIX}${sessionId}`;
};

export const resetProfileWarningReminder = () => {
  localStorage.removeItem(getProfileWarningKey());
};

export const clearLoginSession = () => {
  const sessionId = localStorage.getItem(LOGIN_SESSION_KEY);
  if (sessionId) localStorage.removeItem(`${PROFILE_WARNING_PREFIX}${sessionId}`);
  localStorage.removeItem(LOGIN_SESSION_KEY);
};
